import React from "react";

export default function BottomSection({ onEmailSubmit }) {
	const features = [
		{
			title: "Smart Detection Rules",
			points: ["One trial per device/IP/email", "Block disposable/low-reputation emails", "Scraping & throttling detection", "Detect promo/referral abuse"],
		},
		{
			title: "Advanced Protection",
			points: ["Behavioral entropy & bot detection", "Credit card/device fingerprinting", "Promo & refund abuse analytics", "Velocity & anomaly detection"],
		},
		{
			title: "Plug & Play Templates",
			points: ["One Human, One Trial", "Fake Viral Growth Prevention", "Refund Abuser Flag", "Stealth Scraper Deterrent"],
		},
	];

	return (
		<section className="flex flex-col font-sans items-center justify-center text-black px-4 py-4">
			<h2 className="text-3xl md:text-4xl font-bold mb-8 text-center">Why BeskarOne?</h2>
			<div className="grid md:grid-cols-3 gap-8 w-full max-w-5xl mb-10">
				{features.map((feat, i) => (
					<div key={i} className="bg-white rounded-xl border border-neutral-300 hover:shadow-md transition p-6">
						<h3 className="font-semibold text-xl mb-4">{feat.title}</h3>
						<ul className="list-disc place-items-start pl-5 space-y-2 text-neutral-500 text-base text-left">
							{feat.points.map((pt, j) => (
								<li key={j}>{pt}</li>
							))}
						</ul>
					</div>
				))}
			</div>
		</section>
	);
}
